import React from "react"
import { useHistory } from "react-router"
import styled from "styled-components"

import { H4, Paragraph, LinkWithArrow, Link as _Link } from "components/text"
import { Col } from "components/grid"
import { Box } from "components/box"

import ImageSrcSet from "shared/image-content/image-srcset"
import { ImageAspect } from "shared/image-content/image-types"

import { LearnPost, LearnSections } from "pages/learn/learn-types"
import { FontConfigurations } from "theme"

const ClickableContainer = styled(Box)`
  cursor: pointer;
`

const Link = styled(_Link).attrs({
  ...FontConfigurations.eyebrow
})``

export const PostSummary: React.FC<LearnPost> = ({ imgUrl, imgAlt, section, header, content, path }) => {
  const history = useHistory()

  const learnSection = Object.keys(LearnSections).find(
    key => LearnSections[key as keyof typeof LearnSections] === section
  )

  return (
    <>
      <Col cols={[4, 4, 3.5, 3.5]} push={[0, 0, 1, 1]}>
        <ClickableContainer onClick={() => history.push(path)}>
          <ImageSrcSet src={imgUrl} alt={imgAlt} aspect={ImageAspect.Landscape} />
        </ClickableContainer>
      </Col>
      <Col cols={[4, 4, 6, 6]} push={[0, 0, 0.5, 0.5]} mt={[5, 6, 0, 0]}>
        <Link color="seafoamBlue" to={`/learn/section/${learnSection}`}>
          {section}
        </Link>
        <ClickableContainer onClick={() => history.push(path)}>
          <H4 fontSize={["1.625rem", null, "2rem"]} mt={4}>
            {header}
          </H4>
        </ClickableContainer>
        <Paragraph mt={3}>{content}</Paragraph>
        <LinkWithArrow mt={4} to={path}>
          Read more
        </LinkWithArrow>
      </Col>
    </>
  )
}
